import { loading, success, handleErrorException } from 'State/actions';
import * as types from './types';

export const getCycleMenus = (fromDate, toDate, site, mealType) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.SIMPLE_AVERAGE_LOADING, true));
      const data = {
        IsActive: true,
        Filter: {
          FromDate: fromDate,
          ToDate: toDate,
          Site: site,
          MealType: mealType,
          GetActiveAndInactive: true,
        },
      };
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CycleMenu/GetCycleMenus',
        data
      );

      dispatch(
        success(types.SIMPLE_AVERAGE_GET_CYCLE_MENU_OPTIONS, response.data.Data)
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.SIMPLE_AVERAGE_GET_CYCLE_MENU_OPTIONS_ERROR,
          'Unable to get cycle menus'
        )
      );
    } finally {
      dispatch(loading(types.SIMPLE_AVERAGE_LOADING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/state/simpleaverage/actions.js